import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API, headers: { "Content-Type": "application/json" } });

// --- Rate-limit helpers ---
// Returns true when the server rejected the request with HTTP 429.
export const is429 = (err) => err?.response?.status === 429;

// Parses the Retry-After response header and returns a bounded number of
// seconds we should keep the triggering control disabled for.
// Falls back to 10s and caps at 60s so the visitor is never locked out
// for longer than a moment even if the header advertises a large value.
export const retryAfterSec = (err) => {
  const h = err?.response?.headers?.["retry-after"];
  const n = h ? parseInt(h, 10) : NaN;
  if (Number.isFinite(n) && n > 0) return Math.min(Math.max(n, 5), 60);
  return 10;
};
